export default "__VITE_ASSET__D6T3rWyl__"